import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "../styles/home.scss";
import Layout from "../components/Layout";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TextToSpeech, { speakMessage } from "../components/TextToSpeech";
import LanguageModal from "../components/LanguageModal";
// import CommonService from "../services/CommonService";
import VoiceoverWrapper from "../components/VoiceoverWrapper";
import axios from "axios";
import { FaDownload } from "react-icons/fa6";
import CustomModal from "../components/CustomModal";
import WelcomebackModal from "../components/WelcomebackModal";

const Home = () => {
  const [language, setLanguage] = useState("");
  const [mic, setMic] = useState(true);
  const [speaker, setSpeaker] = useState(true);
  const [voiceTyping, setVoiceTyping] = useState(false);

  // State to keep track of the current slide index
  const [currentSlide, setCurrentSlide] = useState();
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [fade, setFade] = useState(true);

  const sliderSlides = useMemo(
    () => [
      { pdf: "./images/1.jpg", audio: "./audio/1.mp3" },
      { pdf: "./images/2.jpg", audio: "./audio/2.mp3" },
      { pdf: "./images/3.jpg", audio: "./audio/3.mp3" },
      { pdf: "./images/4.jpg", audio: "./audio/4.mp3" },
      { pdf: "./images/5.jpg", audio: "./audio/5.mp3" },
      { pdf: "./images/6.jpg", audio: "./audio/6.mp3" },
      { pdf: "./images/7.jpg", audio: "./audio/7.mp3" },
      { pdf: "./images/8.jpg", audio: "./audio/8.mp3" },
      { pdf: "./images/9.jpg", audio: "./audio/9.mp3" },
      { pdf: "./images/10.jpg", audio: "./audio/10.mp3" },
      { pdf: "./images/11.jpg", audio: "./audio/11.mp3" },
      { pdf: "./images/12.jpg", audio: "./audio/12.mp3" },
      { pdf: "./images/13.jpg", audio: "./audio/13.mp3" },
      { pdf: "./images/14.jpg", audio: "./audio/14.mp3" },
      { pdf: "./images/15.jpg", audio: "./audio/15.mp3" },
      { pdf: "./images/16.jpg", audio: "./audio/16.mp3" },
      { pdf: "./images/17.jpg", audio: "./audio/17.mp3" },
      { pdf: "./images/18.jpg", audio: "./audio/18.mp3" },
      { pdf: "./images/19.jpg", audio: "./audio/19.mp3" },
      { pdf: "./images/20.jpg", audio: "./audio/20.mp3" },
      { pdf: "./images/21.jpg", audio: "./audio/21.mp3" },
      { pdf: "./images/22.jpg", audio: "./audio/22.mp3" },
      { pdf: "./images/23.jpg", audio: "./audio/23.mp3" },
      { pdf: "./images/24.jpg", audio: "./audio/24.mp3" },
      { pdf: "./images/25.jpg", audio: "./audio/25.mp3" },
      { pdf: "./images/26.jpg", audio: "./audio/26.mp3" },
      { pdf: "./images/27.jpg", audio: "./audio/27.mp3" },
      { pdf: "./images/28.jpg", audio: "./audio/28.mp3" },
      { pdf: "./images/29.jpg", audio: "./audio/29.mp3" },
      { pdf: "./images/30.jpg", audio: "./audio/30.mp3" },
      { pdf: "./images/31.jpg", audio: "./audio/31.mp3" },
      { pdf: "./images/32.jpg", audio: "./audio/32.mp3" },
    ],
    []
  );

  // ADD Current Slide to local storage
  useEffect(() => {
    if(currentSlide === sliderSlides.length - 1) {
      localStorage.setItem("ArCurrentSlide", 0);
    }else if (currentSlide !== undefined) {
      localStorage.setItem("ArCurrentSlide", currentSlide);
    }
  }, [currentSlide, sliderSlides.length]);

  // Get Current Slide from local storage
  useEffect(() => {
    const storedSlide = localStorage.getItem("ArCurrentSlide");
    if (storedSlide) {
      setCurrentSlide(parseInt(storedSlide, 10));
    } else {
      setCurrentSlide(0); // Default to the first slide if not found
    }
  }, []);

  console.log("currentSlide", currentSlide);

  // Function to handle language selection
  const handleLanguage = (lang) => {
    if (lang) {
      localStorage.setItem("arcaptorLang", lang);
      setLanguage(lang);
      handleStartVideo();
      setVideoLoaded(false);
      speakMessage("", "", "", "", "", setIsSpeaking);
    }
  };

  // useEffect(() => {
  //   const localLanguage = localStorage.getItem("arcaptorLang");
  //   if (localLanguage) {
  //     setLanguage(localLanguage);
  //   }
  // }, []);

  // Handle forward button click
  const nextSlide = useCallback(() => {
    setFade(false); // Trigger fade-out
    setImgLoaded(false);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderSlides.length); // Update slide
      setFade(true); // Trigger fade-in after updating slide
    }, 500); // Match timeout with fade duration in CSS
  }, [sliderSlides.length]);

  // Handle backward button click
  const prevSlide = () => {
    setFade(false); // Trigger fade-out
    setImgLoaded(false);
    setTimeout(() => {
      setCurrentSlide(
        (prev) => (prev - 1 + sliderSlides.length) % sliderSlides.length
      ); // Update slide
      setFade(true); // Trigger fade-in after updating slide
    }, 500); // Match timeout with fade duration in CSS
  };

  const [conversation_id, setConversation_id] = useState("");

  const handleAskQuestion = async (queryString) => {
    if (!queryString) {
      console.error("Query string is empty");
      return;
    }
    try {
      const res = await axios.post(
        "https://dify.ssbgpt.in/v1/chat-messages",
        {
          inputs: {},
          query: queryString,
          response_mode: "blocking",
          conversation_id: conversation_id || "",
          user: "user-8295",
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_LYRA_API_KEY}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res?.data) {
        setConversation_id(res?.data?.conversation_id);
      }
      return res?.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // PLAY RELATIVE SLIDE AUDIO
  const [imgLoaded, setImgLoaded] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [haveQuestionPopup, setHaveQuestionPopup] = useState(false);
  const [isPauseAudio, setIsPauseAudio] = useState(false);
  const [speaking, setSpeaking] = useState(false);
  const haveQuestionPopupRef = useRef(false);
  const audioRef = useRef(new Audio(sliderSlides[0].audio));
  console.log("imgLoaded", imgLoaded);
  // PLAY AUDIO ON SLIDE CHANGE - CONDITIONALLY
  useEffect(() => {
    if (
      !language ||
      sliderSlides.length === currentSlide ||
      !imgLoaded ||
      haveQuestionPopupRef.current ||
      haveQuestionPopup ||
      !videoLoaded
    ) {
      return;
    }
    const audio = audioRef.current;
    audio.src = sliderSlides[currentSlide].audio;

    audio.play();
    setSpeaking(true);

    // Move to next slide when audio ends
    audio.onended = () => {
      if (currentSlide < sliderSlides.length - 1 && currentSlide !== 0 && currentSlide !== 1) {
        haveQuestionPopupRef.current = true;
        setHaveQuestionPopup(true);
        setSpeaking(false);
      }
      if (!haveQuestionPopupRef.current) {
        if (currentSlide < sliderSlides.length - 1) {
          setImgLoaded(false);
          setCurrentSlide((prevIndex) => prevIndex + 1);
        } else {
          console.log("Slideshow completed!");
        }
      }
      setSpeaking(false);
    };

    return () => {
      audio.onended = null; // Cleanup on unmount
    };
  }, [
    currentSlide,
    sliderSlides,
    language,
    imgLoaded,
    haveQuestionPopup,
    videoLoaded,
  ]);

  // PLAY AUDIO ON ASK QUESTION CLICK POPUP ON SHOW
  const haveQuAudioRef = useRef(new Audio("./audio/haveQuestion.mp3"));
  useEffect(() => {
    if (haveQuestionPopupRef.current || haveQuestionPopup) {
      const audio = haveQuAudioRef.current;
      audio.src = "./audio/haveQuestion.mp3";
      const timeOut = setTimeout(() => {
        audio.play();
      }, 500);

      audio.onended = () => {
        toggleListening();
      };

      return () => {
        audio.onended = null; // Cleanup on unmount
        clearTimeout(timeOut);
      };
    }
  }, [haveQuestionPopup, currentSlide, sliderSlides]);

  // PAUSE AUDIO
  const pauseAudio = () => {
    audioRef.current.pause();
    setIsPauseAudio(true);
    setSpeaking(false);
  };

  // RESUME AUDIO
  const resumeAudio = () => {
    audioRef.current.play();
    setIsPauseAudio(false);
    setSpeaking(true);
    console.log("audio.currentTime", audioRef.current.currentTime);
  };

  // Handle ask question button click
  const handleAskQuestionWrapper = () => {
    if (voiceTyping) {
      setVoiceTyping(false);
      if (!haveQuestionPopup && !haveQuestionPopupRef.current) {
        resumeAudio();
      }
      if (haveQuestionPopup || haveQuestionPopupRef.current) {
        setHaveQuestionPopup(false);
        haveQuestionPopupRef.current = false;
        nextSlide();
        pauseAudio();
      }
    } else {
      setVoiceTyping(true);
      pauseAudio();
    }
  };

  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [text, setText] = useState("");
  const latestText = useRef("");

  // Initialize Speech Recognition
  useEffect(() => {
    if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognitionInstance = new SpeechRecognition();

      recognitionInstance.continuous = false; // Stop automatically after speech ends
      recognitionInstance.interimResults = true;
      recognitionInstance.lang = "en-IN"; // Set language if needed

      recognitionInstance.onresult = (event) => {
        const transcript = Array.from(event.results)
          .map((result) => result[0])
          .map((result) => result.transcript)
          .join("");
        setText(transcript);
        latestText.current = transcript;
      };

      recognitionInstance.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        setIsListening(false);
      };

      recognitionInstance.onspeechend = async () => {
        console.log("User stopped speaking.");
        recognitionInstance.stop();
        setIsListening(false);
      };

      setRecognition(recognitionInstance);
    }
  }, []);

  // Toggle Speech Recognition
  const toggleListening = () => {
    if (isListening) {
      recognition.stop();
      setIsListening(false);
    } else {
      recognition.start();
      setIsListening(true);
    }
  };

  // Handle Yes button click
  const handleYesSelected = useCallback(() => {
    setHaveQuestionPopup(false);
    haveQuestionPopupRef.current = false;
    haveQuAudioRef.current.pause();
    nextSlide();
  }, [nextSlide]);

  // Handle No button click
  const handleNoSelected = () => {
    setVoiceTyping(true);
    audioRef.current.pause();
    haveQuAudioRef.current.pause();
  };

  const [modelResLoading, setModelResLoading] = useState(false);
  const handleVoiceBasedModel = async (query) => {
    if (!query) return;

    try {
      setModelResLoading(true);
      const res = await axios.post(
        "https://dify.ssbgpt.in/v1/chat-messages",
        {
          inputs: {},
          query: query,
          response_mode: "blocking",
          conversation_id: "",
          user: "user-8295",
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_LYRA_YES_NO_KEY}`,
            "Content-Type": "application/json",
          },
        }
      );
      setModelResLoading(false);
      return res?.data || "yes";
    } catch (error) {
      console.error("Error:", error);
      setModelResLoading(false);
      return "yes"; // Default to "yes" in case of error
    }
  };

  useEffect(() => {
    if (latestText.current && !isListening) {
      const trimmedText = latestText.current.trim(); // Get the latest text
      const getResponse = async () => {
        const data = await handleVoiceBasedModel(trimmedText);
        latestText.current = null;
        data.answer = data?.answer?.toLowerCase() || "yes";
        console.log("data.answer", data.answer);
        if (data.answer === "no") {
          handleNoSelected();
        } else {
          handleYesSelected();
        }
      };
      getResponse();
    }
  }, [isListening, handleYesSelected]);

  const circleRef = useRef(null);

  const handleMicClick = () => {
    const circle = circleRef.current;
    const radius = 18;
    const circumference = 2 * Math.PI * radius;

    // Reset for replay
    circle.style.transition = "none";
    circle.style.strokeDashoffset = "0";

    // Force reflow (restarting transition)
    void circle.offsetWidth;

    // Animate
    circle.style.transition = "stroke-dashoffset 3s linear";
    circle.style.strokeDashoffset = `${circumference}`;

    // Optional reset after 3 seconds
    setTimeout(() => {
      circle.style.transition = "none";
      circle.style.strokeDashoffset = "0";
    }, 3100);
  };

  const handleStartOverSlides = () => {
    setCurrentSlide(0);
    handleLanguage("GO_AHEAD");
  };

  // LYRA VIDEO
  const videoRef = useRef(null);

  // Define time ranges
  const speakingRange = useMemo(() => ({ start: 3, end: 9 }), []);
  const idleRange = useMemo(() => ({ start: 12, end: 19 }), []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Update video segment when 'speaking' changes
    const range = speaking ? speakingRange : idleRange;
    video.currentTime = range.start;
    video.play();

    const handleTimeUpdate = () => {
      const currentRange = speaking ? speakingRange : idleRange;
      if (video.currentTime >= currentRange.end) {
        video.currentTime = currentRange.start;
      }
    };

    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [speaking, idleRange, speakingRange]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.setAttribute("webkit-playsinline", "true");
    }
  }, []);

  const handleStartVideo = () => {
    const video = videoRef.current;
    if (video) {
      video.play().catch((err) => console.warn("Autoplay failed:", err));
    }
  };

  return (
    <Layout
      pauseSlide={isPauseAudio ? resumeAudio : pauseAudio}
      isPauseAudio={isPauseAudio}
      showBtn={language}
    >
      {language ? (
        <>
          {/* <div className="container">
            <TextToSpeech text="Hi, i'm Lyra. The A I Company Secretary. How can i assist you." />
          </div> */}
          <div className="home_main">
            <div className="container">
              <div className="content">
                <div className="leftbar">
                  <div className="slider_panel">
                    <img
                      src={sliderSlides[currentSlide]?.pdf}
                      alt="slider"
                      onLoad={() => setImgLoaded(true)}
                      className={`slider-image ${
                        fade ? "fade-in" : "fade-out"
                      }`}
                      style={{
                        // transition: "opacity 0.5s ease-in-out",
                        opacity: imgLoaded ? 1 : 0.5, // Fade-in effect
                      }}
                    />
                  </div>
                  <div className="overlap_logo">
                    <img src="./logo_mobile.png" alt="overlap logo" />
                  </div>
                  <div className="prev_nxt_btns">
                    <button
                      title="Previous Slide"
                      disabled={currentSlide === 0 || !imgLoaded}
                      className={currentSlide === 0 || !imgLoaded ? "disabled" : ""}
                      onClick={prevSlide}
                    >
                      {/* <FaChevronLeft />  */}
                      Prev Slide
                    </button>
                    <button
                      title="Next Slide"
                      disabled={currentSlide === sliderSlides?.length - 1 || !imgLoaded}
                      className={currentSlide === sliderSlides?.length - 1 || !imgLoaded ? "disabled" : ""}
                      onClick={nextSlide}
                    >
                      {/* <FaChevronRight /> */}
                       Next Slide
                    </button>
                  </div>
                </div>
                <div className="rightbar">
                  <div className="modal_img">
                    <div className="captain">
                      {/* <img
                        src="./images/captain-alpha-modal.png"
                        alt="captain alpha"
                      /> */}
                      <video
                        ref={videoRef}
                        onCanPlay={() => setVideoLoaded(true)}
                        src="./videos/lyraVideo.mp4" // Replace with your video path
                        muted
                        autoPlay
                        playsInline
                        loop
                        preload="auto"
                        webkit-playsinline
                        width={640}
                        height={360}
                      />
                      <div className="abt_modal">
                        <h1>Lyra</h1>
                        <p>AI Company Representative</p>
                      </div>
                    </div>
                    <div className="btngrp">
                      <button
                        className="ask_question"
                        onClick={() => handleAskQuestionWrapper()}
                      >
                        Ask Question
                      </button>
                      {sliderSlides.length - 1 === currentSlide && (
                        <a
                          href="./pdf/finalpitchdeck.pdf"
                          download="ArcaptorPitchDeck.pdf"
                          title="📥 Download Pitch Deck"
                        >
                          <FaDownload />
                        </a>
                      )}
                      {/* <button onClick={() => setMic(!mic)}>
                        {mic ? (
                          <img src="./icons/mic-active.png" alt="icon" />
                        ) : (
                          <img src="./icons/mic-inactive.png" alt="icon" />
                        )}
                      </button>
                      <button onClick={() => setSpeaker(!speaker)}>
                        {speaker ? (
                          <img src="./icons/volume-active.png" alt="icon" />
                        ) : (
                          <img src="./icons/volume-inactive.png" alt="icon" />
                        )}
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Voice Over Wapper Start */}
          {voiceTyping && (
            <VoiceoverWrapper
              handleAskQuestionWrapper={handleAskQuestionWrapper}
              handleAskQuestion={handleAskQuestion}
            />
          )}
          {/* Voice Over Wapper Ends  */}

          {/* L:OADER WHEN VIDEO IS NOT LOADED START */}
          {!videoLoaded && (
            <div className="loader_section">
              <div className="loader"></div>
              <img src="./logo_mobile.png" alt="logo_mobile.png" />
            </div>
          )}
          {/* L:OADER WHEN VIDEO IS NOT LOADED ENDS */}
        </>
      ) : currentSlide !== 0 ? (
        <WelcomebackModal
          continue={handleLanguage}
          startOver={handleStartOverSlides}
        />
      ) : (
        <LanguageModal handleLanguage={handleLanguage} />
      )}

      {/* CUSTOM MODAL FOR HAVE QUESTION START */}
      <CustomModal show={haveQuestionPopup} setShow={setHaveQuestionPopup}>
        <div className="have-Question">
          <div className="title">
            Would you like to move on to the next slide, or do you have any
            questions so far?
          </div>
          <div className="btnGrp">
            {/* <button className="yesBtn" onClick={() => handleYesSelected()}>
              Yes
            </button> */}
            <div className="micSection">
              {!modelResLoading && (
                <button className="mic" onClick={toggleListening}>
                  {!isListening ? (
                    <img src="./icons/mic-inactive.png" alt="icon" />
                  ) : (
                    <img src="./icons/mic-active.png" alt="icon" />
                  )}
                </button>
              )}

              {isListening && !modelResLoading ? (
                <>
                  <div className="mic_wave">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <p className="isListening_txt">Speak Now...</p>
                </>
              ) : (
                <p className="isListening_txt">Please Wait...</p>
              )}
              {modelResLoading && <div className="loader"></div>}
            </div>
            {/* <button className="noBtn" onClick={() => handleNoSelected()}>
              No
            </button> */}
          </div>
        </div>
      </CustomModal>
      {/* CUSTOM MODAL FOR HAVE QUESTION ENDS */}
    </Layout>
  );
};

export default Home;
